export const videoDict = (state) => {
    return state.videoDict
}

export const videoList = (state) => {
    return state.videoList
}

export const videoListCN = (state) => {
    return state.videoListCN
}

export const isShowPoster = (state) => {
    return state.isShowPoster
}

export const countryData = (state) => {
    return state.countryData
}

export const countryDict = (state) => {
    return state.countryDict
}

export const userInfo = (state) => {
    return state.userInfo
}

export const userBalance = (state) => {
    return state.userBalance
}

export const nextDailyRewardTime = (state) => {
    return state.nextDailyRewardTime
}

export const sharingVideoURL = (state) => {
    return state.sharingVideoURL
}

export const givePetalVideo = (state) => {
    return state.givePetalVideo
}

export const currentVideo = (state) => {
    return state.currentSelectVideo
}

export const activePoint = (state) => {
    return parseFloat(state.activePoint)
}

export const sharedVideoCount = (state) => {
    return parseInt(state.sharedVideoCount)
}

export const searchCategory = (state) => {
    return state.searchCategory
}
export const searchSubCategory = (state) => {
    return state.searchSubCategory
}

export const searchLanguage = (state) => {
    return state.searchLanguage
}

export const searchSubtitleLanguage = (state) => {
    return state.searchSubtitleLanguage
}



// WEBPACK FOOTER //
// ./src/store/getters.js